"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function gno(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M18.5828 7.875L18.7328 8.12325C19.4808 9.37929 19.8754 10.8141 19.875 12.276C19.8615 16.677 16.3388 20.25 12 20.25H11.9865C7.64779 20.25 4.11154 16.6493 4.12504 12.2482C4.12504 10.7722 4.53304 9.3375 5.28079 8.0955L5.41729 7.8615L6.13804 8.59275C5.99517 8.80158 5.88091 9.0286 5.79829 9.26775C5.52348 10.0293 5.56084 10.8685 5.90224 11.6026C6.24363 12.3366 6.86137 12.906 7.62079 13.1865C8.06725 13.3455 8.54487 13.3971 9.01499 13.3372C9.48511 13.2772 9.93451 13.1074 10.3268 12.8415L12 14.5522L13.9178 12.6068C14.0948 12.7312 14.2988 12.828 14.5163 12.9105C16.0538 13.4625 17.7398 12.648 18.2835 11.103C18.6098 10.1925 18.4605 9.24075 17.9843 8.48175L18.5828 7.875ZM7.02229 9.489L9.27979 11.7653C9.00754 11.9865 8.66779 12.1102 8.30029 12.1102C7.41679 12.1102 6.69529 11.379 6.69529 10.4827C6.69529 10.11 6.81829 9.765 7.02229 9.489ZM14.8973 11.6273L17.1278 9.36525C17.3048 9.62775 17.3993 9.94425 17.3993 10.2758C17.3993 11.172 16.6793 11.9032 15.7943 11.9032C15.4545 11.9032 15.1553 11.8065 14.8973 11.6273ZM12.027 13.338L5.52604 6.7155L5.78404 6.44025C7.38904 4.71525 9.57904 3.75 11.9325 3.75H11.946C14.3265 3.75 16.611 4.785 18.2025 6.5775L18.4478 6.85425L12.0278 13.338H12.027ZM6.58654 6.7155L12.027 12.2482L17.4 6.8265C15.9585 5.364 14.0003 4.5225 11.9603 4.5225H11.946C9.91954 4.5225 8.02954 5.295 6.58729 6.71625L6.58654 6.7155Z", fill: color }));
}
exports["default"] = gno;
//# sourceMappingURL=gno.js.map